<!-- eslint-disable vue/valid-template-root -->
<template></template>

<script>
export default {
  name: 'Feedback',
  props: {
    userId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      scriptUrl: 'https://vkplay.ru/hotbox/feedback/feedback-nps.js',
      isScriptLoaded: false,
      sevenDaysMs: 604800000,
    };
  },
  computed: {
    isTest: () => window.location.search.includes('testFeedback'),
  },
  watch: {
    isScriptLoaded: function () {
      this.run();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.mountEmbeddedFeedback();
    },
    mountEmbeddedFeedback() {
      const regTs =
        window?.VKPlayUser?.session?.client_profile_fields?.reg_ts;

      const diff = regTs
        ? Date.now() - Number(regTs) * 1000
        : this.sevenDaysMs;

      const serveyDelayMs =
        diff > this.sevenDaysMs ? 0 : this.sevenDaysMs - diff;

      const surveys = [
        {
          surveyId: '70',
          delay: this.isTest ? 0 : serveyDelayMs,
          permille: 100,
          triggerEvents: [{ type: 'main_page' }],
        },
        {
          surveyId: '71',
          delay: this.isTest ? 0 : serveyDelayMs,
          permille: 50,
          triggerEvents: [{ type: 'tournament_page' }],
        },
        {
          surveyId: '72',
          delay: this.isTest ? 0 : serveyDelayMs,
          permille: 100,
          triggerEvents: [{ type: 'profile_page' }],
        },
      ];

      const scriptElement = document.createElement('script');
      scriptElement.type = 'text/javascript';
      scriptElement.src = this.scriptUrl;
      document.querySelector('body').append(scriptElement);

      scriptElement.onload = () => {
        window.Feedback.init({
          clientId: this.userId,
          surveys,
          projectName: 'vkplay_desktop_web',
          quarantine: {
            quarantineByShowDays: 7,
            quarantineByAnswerDays: 90,
            quarantineIds: surveys.map((s) => s.surveyId),
          },
        });

        this.isScriptLoaded = true;
      };
    },
    triggerSurvey(pageName, timeout) {
      window.FeedbackEvents.triggerWithDelay(pageName, timeout);
    },
    run() {
      switch (this.$route.name) {
        case 'index':
          this.triggerSurvey('main_page', 5000);
          break;
        case 'tournament':
          this.triggerSurvey('tournament_page', 5000);
          break;
        case 'profile':
          this.triggerSurvey('profile_page', 5000);
          break;
      }
    },
  },
};
</script>
